export default "__VITE_ASSET__28bc24b2__"